import { getTransferStatus, getUserInfo } from "@/utils/auth";
export default {
  methods: {
    getInitTableColumns() {
      let transferName = this.getTransferName();
      let obj = getTransferStatus(transferName);
      if (obj && obj !== "undefined" && obj !== "null") {
        this.masterList.tableColumns = JSON.parse(obj);
      } else {
        this.masterList.tableColumns = this.masterList.initTableColumn;
      }
    },
    getTransferName() {
      let user = JSON.parse(getUserInfo());
      return this.masterList.tableKey + "_" + user.userId;
    },
  },
};
